import actionCreator from 'helpers/actionCreator'
import { ADD_MAP_TO_STATE, UPDATE_MAP_LOCATION, UPDATE_MAP_ZOOM, ZOOM_TO_ALL_DEVICES,
         ZOOM_TO_SINGLE_CAMERA, ZOOM_TO_NETWORK_CLOSET, ZOOM_TO_WIRED_DEVICE,
         ZOOM_TO_DOOR_CONTROLLER, ADD_MAP_COMPONENT_REFERENCES, UPDATE_MAP_TYPE,
         THROTTLE_UPDATE_MAP_LOCATION, GET_STREETVIEW } from 'actions/mapTypes'

export const addMapToStateAction = actionCreator(ADD_MAP_TO_STATE, 'map')
export const updateMapLocationAction = actionCreator(UPDATE_MAP_LOCATION, 'location')
export const updateMapZoomAction = actionCreator(UPDATE_MAP_ZOOM, 'zoom')
export const zoomToAllDevicesAction = actionCreator(ZOOM_TO_ALL_DEVICES)
export const zoomToSingleCameraAction = actionCreator(ZOOM_TO_SINGLE_CAMERA, 'camera', 'checkMaxZoom')
export const zoomToNetworkClosetAction = actionCreator(ZOOM_TO_NETWORK_CLOSET, 'networkCloset', 'checkMaxZoom')
export const zoomToWiredDeviceAction = actionCreator(ZOOM_TO_WIRED_DEVICE, 'wiredDevice', 'checkMaxZoom')
export const zoomToDoorControllerAction = actionCreator(ZOOM_TO_DOOR_CONTROLLER, 'doorController', 'checkMaxZoom')
export const addMapComponentReferencesAction = actionCreator(ADD_MAP_COMPONENT_REFERENCES, 'componentType', 'id', 'references')
export const updateMapTypeAction = actionCreator(UPDATE_MAP_TYPE, 'mapType')
export const throttleUpdateMapLocationAction = actionCreator(THROTTLE_UPDATE_MAP_LOCATION, 'mapType')
export const getStreetviewAction = actionCreator(GET_STREETVIEW, 'componentState')



// WEBPACK FOOTER //
// ./src/actions/mapActions.js